
<template>
  <v-card flat class="futuristic-card">
    <v-form @submit.prevent="searchTerm()" class="card-header">
      <h6 class="earth-color">KEYWORD SEARCH</h6>
      <v-layout row wrap>
        <v-flex lg10 md10 sm10 xs10>
          <v-container>
            <v-text-field
              v-if="route === 'PartnerBookings'"
              label="Search by: Booking Ref, In-House Ref, Client Name, Ticket Number, Vehicle Registration, Email, Phone Number"
              v-model="term.key"
              required
              class="futuristic-input"
            >
            </v-text-field>
            <v-text-field
              v-else-if="
                route === 'BookingsAlert' ||
                route === 'BookingUnticketedAlert'
              "
              label="Search by: Booking Ref"
              v-model="term.key"
              required
              class="futuristic-input"
            ></v-text-field>
            <v-text-field
              v-else-if="route === 'ResidencyProof'"
              label="Search by: Booking Ref, Document ID"
              v-model="term.key"
              required
              class="futuristic-input"
            ></v-text-field>
            <v-text-field
              v-else
              label="Search by: Booking Ref, Client Name, Ticket Number, Organisation Name, Vehicle Registration, School Name, Email, Phone Number"
              v-model="term.key"
              required
              class="futuristic-input"
            ></v-text-field>
          </v-container>
        </v-flex>
        <v-flex lg2 md2 sm2 xs2>
          <v-container fluid>
            <v-btn :depressed="true" color="info" type="submit" class="futuristic-btn">
              <i class="fa fa-search"></i>
            </v-btn>
            <v-btn :depressed="true" color="error" @click="reset()" class="futuristic-btn">Reset</v-btn>
          </v-container>
        </v-flex>
      </v-layout>
    </v-form>
    <hr />
    <v-form @submit.prevent="searchRange()" class="card-header">
      <h6
        v-if="
          route === 'BookingsAlert' ||
          route === 'BookingUnticketedAlert' ||
          route === 'ResidencyProof'
        "
        class="earth-color"
      >
        Search By Creation Date
      </h6>
      <h6 v-else class="earth-color">DATE SEARCH</h6>
      <v-layout row wrap>
        <v-flex
          lg12
          md12
          v-if="route === 'Bookings' || route === 'BookingsReport'"
        >
          <v-container fluid>
            <v-radio-group row v-model="range.date_search" class="futuristic-radio">
              <v-radio
                value="0"
                color="info"
                label="Booking Creation Date"
              ></v-radio>
              <v-radio
                value="1"
                color="info"
                label="Booking Check-In Date"
              ></v-radio>
              <v-radio
                value="2"
                color="info"
                label="Booking Check-Out Date"
              ></v-radio>
              <v-radio
                value="3"
                color="info"
                label="Activity Date"
              ></v-radio>
              <v-radio
                value="4"
                color="info"
                label="Accommodation Arrival Date"
              ></v-radio>
              <v-radio
                value="5"
                color="info"
                label="Accommodation Departure Date"
              ></v-radio>
              <v-radio
                value="6"
                color="info"
                label="In-House Date"
              ></v-radio>
            </v-radio-group>
          </v-container>
        </v-flex>
        <v-flex lg4 md4 sm4 xs12>
          <v-container>
            <v-dialog
              ref="dialog"
              persistent
              v-model="modal1"
              lazy
              full-width
              width="290px"
              :return-value.sync="range.start_date"
            >
              <v-text-field
                slot="activator"
                label="Start Date"
                v-model="range.start_date"
                readonly
                class="futuristic-input"
              ></v-text-field>
              <v-date-picker v-model="range.start_date" scrollable>
                <v-spacer></v-spacer>
                <v-btn
                  :depressed="true"
                  flat
                  color="primary"
                  @click="modal1 = false"
                  class="futuristic-btn"
                >Cancel</v-btn>
                <v-btn
                  :depressed="true"
                  flat
                  color="primary"
                  @click="$refs.dialog.save(range.start_date)"
                  class="futuristic-btn"
                >OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-container>
        </v-flex>
        <v-flex lg4 md4 sm4 xs12>
          <v-container>
            <v-dialog
              ref="dialog1"
              persistent
              v-model="modal2"
              lazy
              full-width
              width="290px"
              :return-value.sync="range.end_date"
            >
              <v-text-field
                slot="activator"
                label="End Date"
                v-model="range.end_date"
                readonly
                class="futuristic-input"
              ></v-text-field>
              <v-date-picker v-model="range.end_date" scrollable>
                <v-spacer></v-spacer>
                <v-btn
                  :depressed="true"
                  flat
                  color="primary"
                  @click="modal2 = false"
                  class="futuristic-btn"
                >Cancel</v-btn>
                <v-btn
                  :depressed="true"
                  flat
                  color="primary"
                  @click="$refs.dialog1.save(range.end_date)"
                  class="futuristic-btn"
                >OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-container>
        </v-flex>
        <v-flex lg2 md2 sm2 xs12>
          <v-container>
            <v-select
              v-if="route === 'BookingsAlert'"
              label="Select Alerts"
              v-model="range.alert_type"
              :items="allAlertTypes"
              :rules="[
                (v) => !!v || 'Pricing Model Type is required',
              ]"
              required
              item-text="value"
              item-value="id"
              :loading="$loadingTrue"
              class="futuristic-input"
            ></v-select>
          </v-container>
        </v-flex>
        <v-flex lg2 md2 sm2 xs12>
          <v-container fluid>
            <v-btn :depressed="true" color="info" type="submit" class="futuristic-btn">
              <i class="fa fa-search"></i>
            </v-btn>
            <v-btn :depressed="true" color="error" @click="reset()" class="futuristic-btn">Reset</v-btn>
          </v-container>
        </v-flex>
      </v-layout>
    </v-form>
  </v-card>
</template>

<script>
import HotelDatePicker from "vue-hotel-datepicker";
export default {
  name: "SearchTabs",
  data() {
    return {
      requiredRules: [(v) => !!v || "This field is required"],
      lmenu: JSON.parse(localStorage.getItem("unem")),
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      term: {
        key: "",
      },
      range: {
        start_date: "",
        end_date: "",
        date_search: "0",
        alert_type: "",
      },
      route: this.$route.name,
    };
  },
  components: {
    HotelDatePicker,
  },
  methods: {
    searchTerm: function () {
      if (this.$route.name === "Bookings") {
        this.$store.dispatch("search_booking_by_key", this.term);
      } else if (this.$route.name === "BookingsReport") {
        this.$store.dispatch("search_booking_by_key_report", this.term);
      } else if (this.$route.name === "ResidencyProof") {
        let data = {
          key: this.term.key,
          isTerm: true,
        };
        this.$store.dispatch("search_proofed_bookings", data);
      } else if (this.$route.name === "PartnerBookings") {
        let data = {
          key: this.term.key,
          partner_id: this.lmenu.instiution_id,
        };
        this.$store.dispatch("search_partner_booking_by_key", data);
      }
    },
    searchRange: function () {
      if (this.$route.name === "Bookings") {
        this.$store.dispatch("search_checked_in_by_date_range", this.range);
      } else if (this.$route.name === "BookingsReport") {
        this.$store.dispatch(
          "search_checked_in_by_date_range_report",
          this.range
        );
      } else if (this.$route.name === "PartnerBookings") {
        let data = {
          start_date: this.range.start_date,
          end_date: this.range.end_date,
          partner_id: this.lmenu.instiution_id,
        };
        this.$store.dispatch("search_partner_booking_by_date_range", data);
      } else if (this.$route.name === "BookingsAlert") {
        this.$store.dispatch("search_inspected_alerted_bookings", this.range);
      } else if (this.$route.name === "BookingUnticketedAlert") {
        this.$store.dispatch("search_unticketed_alerted_bookings", this.range);
      } else if (this.$route.name === "ResidencyProof") {
        this.$store.dispatch("search_proofed_bookings", this.range);
      }
    },
    reset() {
      if (this.$route.name === "Bookings") {
        this.range.start_date = "";
        this.range.end_date = "";
        this.term.key = "";
        this.$store.dispatch("get_all_bookings");
      } else if (this.$route.name === "ResidencyProof") {
        this.range.start_date = "";
        this.range.end_date = "";
        this.term.key = "";
        this.$store.dispatch("get_bookings_residency_proof");
      } else if (this.$route.name === "PartnerBookings") {
        this.$store.dispatch("get_partner_bookings", this.lmenu.instiution_id);
      }
    },
  },
  computed: {
    allAlertTypes: function () {
      let bookingTypes = [
        {
          id: "1",
          value: "Alerts",
        },
        {
          id: "2",
          value: "Non-Alerts",
        },
      ];
      return bookingTypes;
    },
  },
};
</script>

<style scoped>
/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
}

.earth-color {
  color: #4caf50; /* Lighter green for better contrast */
  font-weight: 600;
  margin: 0;
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.futuristic-radio >>> .v-radio {
  margin-right: 16px;
}

.futuristic-radio >>> .v-label {
  color: #0d47a1; /* Darker blue for radio labels */
  font-weight: 500;
}

.futuristic-radio >>> .v-icon {
  color: #4caf50; /* Lighter green for radio icons */
}

hr {
  border-color: #e0e0e0;
  margin: 16px 0;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px;
  }
  
  .futuristic-input {
    max-width: 100%;
    margin-top: 12px;
  }
  
  .futuristic-radio {
    flex-direction: column;
  }
}

@media (max-width: 600px) {
  .futuristic-card {
    border-radius: 6px;
  }
  
  .futuristic-btn {
    font-size: 0.85rem;
  }
}
</style>
